export const menu = {
    label: 'Checkout - Carrinhos',
    icon: 'pi pi-fw pi-shopping-cart',
    to: '/crm/checkout/carrinhos/listagem',
    rules: ['CRM-CHECKOUT-01'],
};
